<template>
  <draggable tag="ul" :list="items" class="list-unstyled chat-list draggable-list" handle=".handle">
    <li
      class="draggable-item"
      v-for="item of items"
      :key="item.id"
      @click="onClick(item)"
      :class="{ active: currentItem && currentItem.id === item.id }"
    >
      <a href="javascript: void(0);" class="media">
        <div class="draggable-item-body overflow-hidden p-2" :class="{inactive: !item.active}">
          <div class="draggable-item-trigger handle"></div>
          <img :src="require('@/assets/images/featured-star.svg')" alt="featured" class="featured-icon" v-if="item.featured"/>
          <p class="text-truncate font-size-16 mb-0">
            {{ item.title }}
          </p>
        </div>
      </a>
    </li>
  </draggable>
</template>

<script>
import draggable from "vuedraggable";
export default {
  name: "draggable-list",
  props: {
    items: {
      type: Array
    }
  },
  components: {
    draggable
  },
  data () {
    return {
      currentItem: null
    }
  },
  methods: {
    onClick (item) {
      this. currentItem = item
      this.$emit('click', item)
    }
  }     
}
</script>
